import React from "react";

/**
 * Inline notice for a feature whose backend endpoint is not wired up yet.
 * Rendered upfront — next to the action it blocks — so nobody fills in a form
 * that cannot be submitted. See UNAVAILABLE_FEATURES in UserSlice.
 */
export default function FeatureUnavailableNotice({
  message = "This feature is not available yet. Please check back later.",
  className = "",
}) {
  return (
    <p className={`text--medium feature-unavailable-notice ${className}`}>
      <i className="bi bi-info-circle"></i> {message}
    </p>
  );
}
